import React, { useEffect, useState, createContext } from 'react'
import './App.css'
// ROUTER
import { BrowserRouter, Routes, Route, useParams } from "react-router-dom"
// PAGES
import Home from './pages/serveur/home/Home'
import AjouterEntreprise from './pages/ajouterEntreprise/AjouterEntreprise'
import NotFound from './pages/notFound/NotFound'
import SiteWeb from './pages/serveur/siteWeb/SiteWeb'
import Profil from './pages/serveur/profil/Profil'
import Parametres from './pages/serveur/parametres/Parametres'
import useFirebase from './firebase/useFirebase'
import MessagePush from './pages/serveur/messagePush/MessagePush'
import Forfait from './pages/serveur/forfait/Forfait'
import HomeUsers from './pages/users/homeUsers/HomeUsers'
import Services from './pages/serveur/services/Services'
import Staff from './pages/serveur/staff/Staff'
import Planning from './pages/serveur/planning/Planning'
import Montest from './pages/Montest'
import HorairesStaff from './pages/serveur/staff/HorairesStaff'
import PageTest from './pages/PageTest'
import Auth from './pages/serveur/authentification/Auth'
import useAuthFirebase from './firebase/useAuthFirebase'
import MyFirebase from './pages/MyFirebase'
import TestPlanning from './pages/TestPlanning'
import AuthUser from './pages/users/authUser/AuthUser'
import HomeAdministrateur from './pages/serveur/administrateur/home/HomeAdministrateur'
import CreateAccountAdministrateur from './pages/serveur/administrateur/createAccount/CreateAccountAdministrateur'
import Clients from './pages/serveur/clients/Clients'
import Client from './pages/serveur/clients/client/Client'
import ClientBooking from './pages/serveur/clients/client/ClientBooking'
import BookingUsersPage from './pages/users/bookingUsers/BookingUsersPage'
import HorairesUsersPage from './pages/users/horaires/HorairesUsersPage'
import NousSituerUsersPage from './pages/users/nousSituer/NousSituerUsersPage'
import PhoneUsersPage from './pages/users/phone/PhoneUsersPage'
import ChatUsersPage from './pages/users/chat/ChatUsersPage'
import Chat from './pages/serveur/chat/Chat'
import ChatSingle from './pages/serveur/chat/ChatSingle'
import ProfilStaff from './pages/serveur/staff/ProfilStaff'
import AbsencesStaff from './pages/serveur/staff/AbsencesStaff'
import PageFilterUserServeur from './pages/PageFilterUserServeur'
import HomePageEquipe from './pages/equipe/homePageEquipe/HomePageEquipe'
import PlanningEquipe from './pages/equipe/planningEquipe/PlanningEquipe'
import ChatEquipe from './pages/equipe/chatEquipe/ChatEquipe'
import ProfilEquipe from './pages/equipe/profilEquipe/ProfilEquipe'
import VacancesEquipe from './pages/equipe/vacancesEquipe/VacancesEquipe'
import HorairesEquipe from './pages/equipe/horairesEquipe/HorairesEquipe'

// CONTEXT
export const AppContext = createContext()
 

function App() {
  const {  } = useFirebase()
  const { user, _onAuth } = useAuthFirebase()

  useEffect(() => {
    _onAuth()
  },[])

  return (
    <AppContext.Provider value={{ user }}> 
      <BrowserRouter>
        <Routes>
          <Route path="/filterUserServeur" element={<PageFilterUserServeur />} />
          <Route path="/homeServeur" element={<Home />} />
          <Route path="/homeUser/:keyUid/:tokenUser" element={<HomeUsers />} />
          <Route exact path="/authUser" element={<AuthUser />} />
          <Route exact path="/bookingUsersPage" element={<BookingUsersPage />} />
          <Route exact path="/horairesUsersPage" element={<HorairesUsersPage />} />
          <Route exact path="/nousSituerUserPage" element={<NousSituerUsersPage />} />
          <Route exact path="/phoneUsersPage" element={<PhoneUsersPage />} />
          <Route exact path="/chatUsersPage" element={<ChatUsersPage />} />
          
          <Route exact path="/clients" element={<Clients />} />
          <Route exact path="/client" element={<Client />} />
          <Route exact path="/clientBooking" element={<ClientBooking />} />

          <Route exact path="/auth" element={<Auth />} />
          <Route exact path="/ajouterEntreprise" element={<AjouterEntreprise />} />
          <Route exact path="/siteWeb" element={<SiteWeb />} />
          <Route exact path="/messagePush" element={<MessagePush />} />
          <Route exact path="/profil" element={<Profil />} />
          <Route exact path="/forfait" element={<Forfait />} />
          <Route exact path="/parametres" element={<Parametres />} />
          <Route exact path="/services" element={<Services />} />
          <Route exact path="/staff" element={<Staff />} />
          <Route exact path="/profilStaff" element={<ProfilStaff />} />
          <Route exact path="/horairesStaff" element={<HorairesStaff />} />
          <Route exact path="/absencesStaff" element={<AbsencesStaff />} />
          <Route exact path="/planning" element={<Planning />} />
          <Route exact path="/chat" element={<Chat />} />
          <Route exact path="/chatSingle" element={<ChatSingle />} />

          {/* <Route exact path="/pageTest/:id" element={<PageTest />} /> */}

          <Route exact path="/pageTest" element={<PageTest />} /> 
          <Route exact path="/" element={<Montest />} />
          <Route exact path="/montest" element={<HomeUsers />} />
          <Route exact path="/monuid" element={<HomeUsers />} />
          
          <Route exact path="/nomEntreprise/authUser" element={<AuthUser />} />


          {/* EQUIPE */}
          <Route exact path="/homePageEquipe" element={<HomePageEquipe />} />
          <Route exact path="/planningEquipe" element={<PlanningEquipe />} />
          <Route exact path="/chatEquipe" element={<ChatEquipe />} />
          <Route exact path="/profilEquipe" element={<ProfilEquipe />} />
          <Route exact path="/horairesEquipe" element={<HorairesEquipe />} />
          <Route exact path="/vacancesEquipe" element={<VacancesEquipe />} />

          {/* ADMINISTRATEUR */}
          {user.uid === 'Ui9uUy6IRsXMUk5AgznTDvTeErF3' &&
          <>
          <Route exact path="/administrateur" element={<HomeAdministrateur />} />
          <Route exact path="/administrateur/createAccount" element={<CreateAccountAdministrateur />} />
          </>
          }

          <Route element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </AppContext.Provider>
  )
}

export default App

/*

http://localhost:3000/homeUser/Z1NJJ5CuMoP28U12gxqQoR5NkvG2/45465456456

*/
